// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"46132bfd","80":"dfdd334d","443":"8f6592ba","453":"440f6b9c","580":"63227866"}[chunkId] + ".chunk.js";
};